// AdSense configuration
export const AD_CONFIG = {
  // Your AdSense client ID
  clientId: 'ca-pub-4977871913539025',
  
  // Ad slot IDs (replace with your actual ad slot IDs)
  slots: {
    blogBanner: '1234567890',      // Banner ad for blog pages
    blogSidebar: '0987654321',     // Sidebar ad for blog pages  
    blogInContent: '1122334455',   // In-content ad for blog posts
    blogList: '5566778899',        // Ad for blog list page
  },
  
  // Ad formats
  formats: {
    banner: 'auto',
    sidebar: 'vertical', 
    inContent: 'rectangle',
    list: 'auto'
  }
} as const;

// Helper function to check if we should show ads
export const shouldShowAds = (): boolean => {
  try {
    return typeof window !== 'undefined' && window.location.pathname.startsWith('/blog');
  } catch {
    return false;
  }
};

// Helper function to get ad slot by type
export const getAdSlot = (type: keyof typeof AD_CONFIG.slots): string => {
  return AD_CONFIG.slots[type];
};
